import { render, staticRenderFns } from "./MgmIntro.vue?vue&type=template&id=77e38f65&scoped=true&"
import script from "./MgmIntro.vue?vue&type=script&lang=js&"
export * from "./MgmIntro.vue?vue&type=script&lang=js&"
import style0 from "./MgmIntro.vue?vue&type=style&index=0&id=77e38f65&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e38f65",
  null
  
)

export default component.exports